import axios from 'axios';
import storage from 'store';
import notification from 'ant-design-vue/es/notification';
import { Modal } from 'ant-design-vue';
import router from '../router';

const ACCESS_TOKEN = 'ACCESS_TOKEN';
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 60000, // 请求超时时间
});

// 异常拦截处理器
const errorHandler = (error) => {
  console.log(`requesterror:${error}`);
  if (error.response) {
    const { data } = error.response;
    // 从 localstorage 获取 token
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message,
      });
    }
    if (error.response.status === 406) {
      notification.error({
        message: '错误',
        description: data.message,
      });
    }
    // if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
    //   notification.error({
    //     message: 'Unauthorized',
    //     description: 'Authorization verification failed',
    //   });
    // }
  }
  notification.error({
    message: 'Error',
    description: JSON.stringify(error.message),
  });
  return Promise.reject(error);
};

// request interceptor
request.interceptors.request.use((config) => {
  const token = storage.get(ACCESS_TOKEN);
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, errorHandler);
// 统一业务返回处理
const commonResponseHandler = (response) => {
  // console.log(`commonResponse:${JSON.stringify(response)}`);
  // 验证信息错误
  if ((response.code === 402 || response.code === 508) && window.location.pathname !== '/user/login') {
    Modal.confirm({
      title: '验证信息过期',
      content: '请重新登录',
      onOk() {
        router.push('/user/login');
      },
    });
    storage.remove(ACCESS_TOKEN);
    return Promise.reject(response);
  }
  // 验证信息错误
  if (response.code === 422) {
    notification.error({
      message: '参数验证错误',
      description: response.message,
    });
  }
  if (response.code === 9001 | response.code === 7001) {
    notification.error({
      message: '错误提示',
      description: response.message,
    });
  }
  // 最后还是会返回给业务处理
  return Promise.resolve(response);
};
// response interceptor
request.interceptors.response.use((response) => commonResponseHandler(response.data), errorHandler);

export default request;
